import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { getPublicContracts } from "../../../setup/api/services/contract";
import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";
import Paginations from "../../common/Pagination/paginations";
import Spinner from "../../common/Spinner";
import ContractListItem from "../../contractListItem";
import styles from "./styles.module.scss";

interface Props {
  userId: string;
}

const Contract = ({ userId }: Props) => {
  const { t } = useTranslation();
  const [contracts, setContracts] = useState<IContractDetailsResponseData[]>(
    []
  );
  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(0);

  const [loading, setLoading] = useState<boolean>(true);

  const fetchContracts = useCallback(
    async (userId: string) => {
      setLoading(true);
      try {
        const body = {
          senderId: String(userId),
          page,
          size: 4,
        };
        const response = await getPublicContracts(body);
        setContracts(response.data.content);
        setPageCount(response.data.totalPages);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
    [page]
  );

  useEffect(() => {
    if (userId) fetchContracts(userId);
  }, [fetchContracts, page, userId]);

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner />
      </div>
    );
  }

  if (contracts?.length === 0) {
    return (
      <div className={styles.emptyContainer}>
        <img src="/assets/images/svg/emptyContracts.svg" />
        <div className={styles.header}>
          <h2>{t("lbl_current_contract_list_empty_state_title")}</h2>
          <p className={styles.p1}>{t("lbl_no_available_ratings")}</p>
        </div>
      </div>
    );
  }

  const handlePaginationChange = (value: number) => {
    setPage(value - 1);
  };

  return (
    <div className={styles.container}>
      <div className={styles.contract_list}>
        {contracts.map((contract: IContractDetailsResponseData) => {
          return (
            <div className={styles.list_wrapper} key={contract.id}>
              <ContractListItem userId={userId} contract={contract} />
            </div>
          );
        })}
      </div>
      <Paginations
        pagesCount={pageCount}
        page={page + 1}
        length={10}
        handlePaginationChange={handlePaginationChange}
      />
    </div>
  );
};

export default Contract;
